import { InjectionToken } from '@angular/core';

/**
 * Set to true:
 *   - for required fields : add "*" after field label
 *   - for optional fields : keep label untouched
 *
 * Set to false:
 *   - for required fields : keep label untouched
 *   - for optional fields : add "(optional)" after field label
 */
export const HIGHLIGHT_REQUIRED_INPUTS = new InjectionToken<boolean>(
  'highlight-required-inputs'
);
